import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import Timer from '../../../../components/Timer';
import { COLOR_SUCCESSFUL, COLOR_ERROR, roles, VEHICLE_STATUSES } from '../../../../constants';
import { SectionTitle, SectionWrapper } from './index';
import { useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { OfferAuctionStatus } from 'types/vehicle';

const StyledGridWrapper = styled(Grid)`
  @media (min-width: 600px) {
    > div:not(:first-child) {
      border-left: 1px solid #dcdcdc;
    }
  }
`;

const StyledGrid = styled(Grid)`
  margin-top: 10px;
  font-weight: 500;
  text-align: center;
  &:not(:first) {
    border-left: 1px solid #dcdcdc;
  }
  @media (max-width: 599px) {
    text-align: left;
  }
`;

const StyledTextWithoutOverflow = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

const StyledHighestBidder = styled(Typography)`
  display: inline;
  color: ${COLOR_SUCCESSFUL};
`;

const StyledOutbidded = styled(Typography)`
  display: inline;
  color: ${COLOR_ERROR};
`;

const StyledNumberFormat = styled(NumberFormat)`
  color: #06a000;
`;

const OfferSummarySection = ({ currentUser, vehicle }) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);

  const topOffer = offerAuction?.offerBids?.[0];
  const proxyOffer = offerAuction?.offerProxyBid;

  const showProxy = currentUser.role === roles.BUYER && proxyOffer && proxyOffer?.user_id === currentUser.id;
  const isUserBuyer = currentUser.role === roles.BUYER;

  return (
    <SectionWrapper>
      <SectionTitle>
        Offer summary
        <StyledHighestBidder component="span">
          {isUserBuyer && topOffer?.user_id === currentUser.id && ' (You’re the top offer)'}
        </StyledHighestBidder>
        <StyledOutbidded component="span">
          {isUserBuyer && topOffer?.user_id !== currentUser.id && ' (Your offer has been outbid)'}
        </StyledOutbidded>
      </SectionTitle>
      <StyledGridWrapper container>
        <StyledGrid container direction="column" item xs={12} sm={4}>
          <Typography gutterBottom variant="caption">
            Current Offer
          </Typography>
          {topOffer ? (
            <>
              <StyledNumberFormat displayType="text" prefix="$" value={topOffer.amount} thousandSeparator />
              {showProxy && (
                <Typography>
                  (
                  <NumberFormat displayType="text" prefix="$" value={proxyOffer?.amount} thousandSeparator /> max)
                </Typography>
              )}
            </>
          ) : (
            <span>$0</span>
          )}
        </StyledGrid>
        <StyledGrid container direction="column" item xs={12} sm={4}>
          <Typography gutterBottom variant="caption">
            Highest Offer
          </Typography>
          <StyledTextWithoutOverflow title={topOffer?.bidder?.dealership_name || 'N/A'}>
            {topOffer?.bidder?.dealership_name || 'N/A'}
          </StyledTextWithoutOverflow>
        </StyledGrid>
        <StyledGrid container direction="column" item xs={12} sm={4}>
          <Typography gutterBottom variant="caption">
            Time Remaining
          </Typography>
          <Timer withColors toDate={null} />
        </StyledGrid>
      </StyledGridWrapper>
    </SectionWrapper>
  );
};

export default OfferSummarySection;
